import { useState } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CardAction from '../../../components/card/CardAction';
import LessonPlay from '../../lessonplay/LessonPlay';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './PlayLessonAction.scss';

/**
 * Play Lesson Action Container
 */
const defaultProps = {
  label: '',
  className: '',
  user: null,
  userProfile: null,
  onLessonFinished: () => { },
  terminologies: {},
};

export default function PlayLessonAction(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { lesson, label, className, user, userProfile, onLessonFinished, terminologies } = mergedProps;
  const [open, setOpen] = useState(false);

  return (
    <>
      <CardAction
        icon={<PlayArrowIcon aria-hidden='false' />}
        label={label}
        actionHandler={() => { setOpen(true); }}
        className={`btn-gray-background play-lesson-card-action ${className}`}
        data-test={`play-lesson-card-action-${lesson.id}`}
        tabIndex={0}
        aria-hidden='false'
      />
      {open && (
        <LessonPlay
          open={open}
          handleClose={() => { setOpen(false); }}
          lesson={lesson}
          user={user}
          userProfile={userProfile}
          onLessonFinished={onLessonFinished}
          terminologies={terminologies}
        />
      )}
    </>
  );
}
